import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {CreateXpertKnowledgeCommentBody, DeleteXpertKnowledgeCommentBody, UpdateXpertKnowledgeCommentBody, XpertKnowledgeCommentDto} from './type'

class XpertKnowledgeCommentServiceProvider extends ApiService {
  async create(body: CreateXpertKnowledgeCommentBody): Promise<XpertKnowledgeCommentDto> {
    return this.post<XpertKnowledgeCommentDto>(`/xpert-knowledge/comments`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async remove(body: DeleteXpertKnowledgeCommentBody): Promise<void> {
    return this.delete<void>(`/xpert-knowledge/comments`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async update(body: UpdateXpertKnowledgeCommentBody): Promise<XpertKnowledgeCommentDto> {
    return this.patch<XpertKnowledgeCommentDto>(`/xpert-knowledge/comments`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAll(xpertKnowledgeId: string): Promise<XpertKnowledgeCommentDto[]> {
    return this.get<XpertKnowledgeCommentDto[]>(`/xpert-knowledge/${xpertKnowledgeId}/comments`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeCommentService = new XpertKnowledgeCommentServiceProvider()
